/* esm.sh - unhead@2.1.12 */
export * from "/*unhead@2.1.12/esnext/unhead.mjs";
